import React from 'react';
import { css } from '@emotion/react';
import { ReactNode } from 'react';
import { theme } from 'styles/theme';

export const FormSectionHeading = ({
	children,
	desc,
	first,
}: {
	children: ReactNode;
	desc?: ReactNode;
	first?: boolean;
}) => {
	return (
		<>
			<div
				css={css`
					margin-top: 32px;
					margin-bottom: 20px;
					color: ${theme.color.primary['400']};
					font-size: 16px;
					line-height: 20px;

					${first &&
					css`
						margin-top: 0;
					`}
				`}
			>
				{children}
			</div>
			{desc && (
				<div
					css={css`
						color: ${theme.color.text['300']};
						line-height: 20px;
						font-size: 14px;
						margin-bottom: 20px;
					`}
				>
					{desc}
				</div>
			)}
		</>
	);
};
